export default function getQuoteTypeFromID(quoteTypeID) {
    switch (quoteTypeID) {
        case 0:
            return "Unknown"
        case 1:
            return "Life";
        case 2: 
            return "Disability";
        case 3:
            return "LTC";

        default:
            return '';
    }
}


// WEBPACK FOOTER //
// ./src/components/Common/GetQuoteTypeFromID.js